module.exports = __webpack_public_path__ + "img/Certificate.4f1ecd32.jpg";